export default __webpack_public_path__ + "static/9-a839060decb8999f35addbfb19ce499d.jpg";